export default class EzException {
    message = null;
    error_code = null;

    constructor(message, error_code) {
        this.message = message;
        this.error_code = error_code;
    }
}